module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1047.437c06c4.png";